import styled from 'styled-components'
import { DURATIONS, EASING, GRADIENTS, RADII } from 'styles/consts'

export const UpgradeButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 9px 17px;
  gap: 10px;
  height: 34px;
  margin-right: 24px;
  border-radius: ${RADII.field};
  box-sizing: border-box;
  cursor: pointer;
  background: ${GRADIENTS.premium};

  transition: transform ${DURATIONS.fast} ${EASING.out};

  &:hover {
    background: ${GRADIENTS.premiumHover};
  }

  &:active {
    transform: scale(0.97);
  }

  // This is the animation that is applied to the button

  animation: upgrade-pulse 2s ease 0s infinite normal none running;
  @keyframes upgrade-pulse {
    0% {
      box-shadow: rgba(65, 54, 193, 0.4) 0px 0px 0px 0px;
    }
    100% {
      box-shadow: rgba(65, 54, 193, 0) 0px 0px 0px 5px;
    }
  }

  // This is the animation that is applied to the crown icon

  svg {
    animation: rotate-scale-up 4s linear 0s infinite normal none running;
  }

  @keyframes rotate-scale-up {
    0% {
      transform: scale(1) rotateY(0deg);
    }
    20% {
      transform: scale(0.9) rotateY(0deg);
    }
    30% {
      transform: scale(1.2) rotateY(180deg);
    }
    40% {
      transform: scale(0.9) rotateY(0deg);
    }
    60%,
    100% {
      transform: scale(1);
    }
  }
`
